import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AdminLayout from '@/components/layouts/AdminLayout';
import UserManagement from './UserManagement';
import ProspectManagementTab from './ProspectManagementTab';
import { Users, Building2 } from 'lucide-react';

const Management = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <AdminLayout>
      <div className="p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Management</h1>
          <p className="text-gray-600 mt-2">Manage users and prospects</p>
        </div>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="users" className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              Users
            </TabsTrigger>
            <TabsTrigger value="prospects" className="flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              Prospects
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="users" className="mt-6">
            <UserManagement />
          </TabsContent>
          
          <TabsContent value="prospects" className="mt-6">
            <ProspectManagementTab />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
};

export default Management; 